import { redirect } from '@tanstack/react-router'
import { RouterContext } from '@/routes/__root'
import validateAppDest from '@/common/lib/validateAppDest'

/**
 * Check if user is authenticated and verified.
 * Throws redirect if not.
 *
 * Assumes auth bootstrap is already complete (enforced by BootstrapGate
 * in index.tsx which gates RouterProvider until bootstrapped).
 *
 * @param redirectBackOnLogin - If true, includes redirect URL in login search params
 */
export function requireAuth(context: RouterContext, redirectBackOnLogin = true) {
  const currentUser = context.currentUser

  if (!currentUser?.isAuthenticated) {
    const from = `${window.location.pathname}${window.location.search}`
    const search = redirectBackOnLogin && validateAppDest(from) ? { from } : undefined
    throw redirect({ to: '/app/account/login', search })
  }

  if (!currentUser.isVerified) {
    throw redirect({
      to: '/app/account/register/verification',
    })
  }
}
